export const getJWTToken = () => {
  return localStorage.getItem('jwt');
};
